
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contests/zhenit-nelzya-pomilovat",
      function () {
        return require("private-next-pages/contests/zhenit-nelzya-pomilovat.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contests/zhenit-nelzya-pomilovat"])
      });
    }
  